import React from 'react';
import { motion } from 'framer-motion';

export default function Founder() {
  return (
    <section className="py-20 bg-stone-100">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div 
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="bg-white rounded-3xl shadow-xl overflow-hidden flex flex-col md:flex-row items-center md:items-stretch"
        >
          {/* Prominent Profile Picture - Taller and larger to balance the text box */}
          <div className="md:w-2/5 p-8 md:p-10 flex justify-center items-center bg-stone-50 md:bg-white">
            <img
              src="https://i.ibb.co/QFNLjPPw/Stu.webp"
              alt="Stu Donald - Land Specialist"
              className="w-64 h-64 md:w-72 md:h-[22rem] lg:w-80 lg:h-[26rem] object-cover object-center rounded-2xl shadow-md border-4 border-white"
            />
          </div>
          
          {/* Personal Message */}
          <div className="md:w-3/5 p-8 md:py-12 md:pr-12 flex flex-col justify-center">
            <h3 className="text-2xl md:text-3xl font-serif font-bold text-stone-900 mb-4">
              A Personal Note from Stu
            </h3>
            <div className="text-stone-600 space-y-4 text-lg leading-relaxed">
              <p>
                "Hi, I'm Stu. I know that selling land the traditional way can feel like a slow, stiff, and deeply frustrating process. You often get handed off between different agents and end up dealing with faceless corporate buyers who treat you like a number."
              </p>
              <p>
                "That's exactly why our team at Land Quick does things differently. When you reach out to us, you're dealing with real people who genuinely care about making this as simple, honest, and stress-free as possible. No corporate runarounds, no hidden fees—just a fair offer and a handshake you can trust."
              </p>
            </div>
            
            <div className="mt-8 pt-6 border-t border-stone-100">
              <p className="font-bold text-stone-900 text-xl font-serif">Stu Donald</p>
              <p className="text-brand-600 font-medium">Lead Land Specialist</p>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
}